import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    imprestApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
  imprestApprover,
  approvedDisbursedImprests,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, imprestApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import ImprestApplicationForm from "./form";
import ImprestApprovalsTable from "../ImprestApplications";
import ImprestDocumentsDrawer from "./ImprestDocumentsDrawer";

const base_url = HRService.uri;

function ImprestApprovedDisbursedTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

  const actions = {
  entity: "/imprest-approved-disbursed",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

//  // ---------- APPROVE ----------
//   APPROVEIMPREST: {
//     key: "APPROVEIMPREST",
//     button_name: "Approve",
//     Show_Button: (row) => row.statusId === 1,   // only when pending
//     permission: "hasNoPermission",
//     roleGroupId: [1, 2, 3, 4],
//   },

//   // ---------- REJECT ----------
//   REJECTIMPREST: {
//     key: "REJECTIMPREST",
//     button_name: "Reject",
//     Show_Button: (row) => row.statusId === 1,   // only when pending
//     permission: "hasNoPermission",
//     roleGroupId: [1, 2, 3, 4],
//   },
 ViewImprestLines: {
      key: "ViewImprestLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },
  showStatus: true,
};

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Approved Disbursed Imprest Applications"
          subtitle="View all your Approved Disbursed Imprest Applications, create or update it"
          columns={imprestApplicationsColumns}
          FormComponent={ImprestApplicationForm}
          query={approvedDisbursedImprests}
          actions={actions}
          base_url={base_url}
        />
        <ImprestDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedRecordForDocs(null);
          }}
          imprestId={selectedRecordForDocs?.id}
        />
      </>
    </Box>
  );
}

export default ImprestApprovedDisbursedTable;
